import circleAlertTypes from '@/utils/constants/student/circleAlertTypes.js';

//import circle images
import CIRCLE_IMAGE_ONE from '@/assets/img/circle_alert_one.svg';
import CIRCLE_IMAGE_TWO from '@/assets/img/circle_alert_two.svg';
import CIRCLE_IMAGE_THREE from '@/assets/img/circle_alert_three.svg';
import CIRCLE_IMAGE_FOUR from '@/assets/img/circle_alert_four.svg';

const mutations = {
  setAlert(state, payload) {
    state.alerts = payload.map((item) => {
      switch (item.type) {
        case circleAlertTypes.CircleOne:
          item.image = CIRCLE_IMAGE_ONE;
          break;
        case circleAlertTypes.CircleTwo:
          item.image = CIRCLE_IMAGE_TWO;
          break;
        case circleAlertTypes.CircleThree:
          item.image = CIRCLE_IMAGE_THREE;
          break;
        case circleAlertTypes.CircleFour:
          item.image = CIRCLE_IMAGE_FOUR;
          break;
        default:
          item.image = CIRCLE_IMAGE_ONE;
      }
      return item;
    });
  },
  setAlertsDetails(state, payload) {
    state.alertsDetails.data = payload.data;
    state.alertsDetails.paging = {
      count: payload.count,
      currentPage: payload.currentPage,
      pageCount: payload.pageCount,
      totalItemCount: payload.totalItemCount,
    };
  },
  setMessage(state, payload) {
    state.messages = {
      data: payload.length > 0 ? payload[0] : [],
      chunked: payload.length > 0 ? payload.slice(1) : [[]],
    };
  },
  setImmediateMessage(state, payload) {
    state.immediateMessages = payload;
  },
  setMessagesMoreRows(state) {
    state.messages = {
      ...state.messages,
      data: [...state.messages.data, ...state.messages.chunked[0]],
    };
    state.messages.chunked.shift(0);
  },
  setSchedule(state, payload) {
    state.schedule = payload;
  },
};

export default mutations;
